'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (ComposedComponent, spinnerProps) {
  spinnerProps = Object.assign({}, defaultSpinnerProps, spinnerProps);

  function withLoader(props) {
    return props.isLoading ? _react2.default.createElement(_Spinner2.default, spinnerProps) : _react2.default.createElement(ComposedComponent, props);
  }

  withLoader.displayName = 'withLoader(' + ComposedComponent.displayName + ')';

  withLoader.propTypes = {
    isLoading: _propTypes2.default.bool.isRequired
  };

  return withLoader;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('./Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var majorScale = _theme2.default.majorScale;


var defaultSpinnerProps = {
  marginX: 'auto',
  marginY: majorScale(8)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL3dpdGhMb2FkZXIuanMiXSwibmFtZXMiOlsiQ29tcG9zZWRDb21wb25lbnQiLCJzcGlubmVyUHJvcHMiLCJPYmplY3QiLCJhc3NpZ24iLCJkZWZhdWx0U3Bpbm5lclByb3BzIiwid2l0aExvYWRlciIsInByb3BzIiwiaXNMb2FkaW5nIiwiZGlzcGxheU5hbWUiLCJwcm9wVHlwZXMiLCJib29sIiwiaXNSZXF1aXJlZCIsIm1ham9yU2NhbGUiLCJtYXJnaW5YIiwibWFyZ2luWSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O2tCQVdlLFVBQVVBLGlCQUFWLEVBQTZCQyxZQUE3QixFQUEyQztBQUN4REEsaUJBQWVDLE9BQU9DLE1BQVAsQ0FBYyxFQUFkLEVBQWtCQyxtQkFBbEIsRUFBdUNILFlBQXZDLENBQWY7O0FBRUEsV0FBU0ksVUFBVCxDQUFxQkMsS0FBckIsRUFBNEI7QUFDMUIsV0FBT0EsTUFBTUMsU0FBTixHQUNILGlEQUFhTixZQUFiLENBREcsR0FFSCw4QkFBQyxpQkFBRCxFQUF1QkssS0FBdkIsQ0FGSjtBQUdEOztBQUVERCxhQUFXRyxXQUFYLG1CQUF1Q1Isa0JBQWtCUSxXQUF6RDs7QUFFQUgsYUFBV0ksU0FBWCxHQUF1QjtBQUNyQkYsZUFBVyxvQkFBVUcsSUFBVixDQUFlQztBQURMLEdBQXZCOztBQUlBLFNBQU9OLFVBQVA7QUFDRCxDOztBQTNCRDs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0lBQ1FPLFUsbUJBQUFBLFU7OztBQUVSLElBQU1SLHNCQUFzQjtBQUMxQlMsV0FBUyxNQURpQjtBQUUxQkMsV0FBU0YsV0FBVyxDQUFYO0FBRmlCLENBQTVCIiwiZmlsZSI6IndpdGhMb2FkZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgU3Bpbm5lciBmcm9tICcuL1NwaW5uZXInXG5pbXBvcnQgdGhlbWUgZnJvbSAnLi90aGVtZSdcbmNvbnN0IHsgbWFqb3JTY2FsZSB9ID0gdGhlbWVcblxuY29uc3QgZGVmYXVsdFNwaW5uZXJQcm9wcyA9IHtcbiAgbWFyZ2luWDogJ2F1dG8nLFxuICBtYXJnaW5ZOiBtYWpvclNjYWxlKDgpXG59XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIChDb21wb3NlZENvbXBvbmVudCwgc3Bpbm5lclByb3BzKSB7XG4gIHNwaW5uZXJQcm9wcyA9IE9iamVjdC5hc3NpZ24oe30sIGRlZmF1bHRTcGlubmVyUHJvcHMsIHNwaW5uZXJQcm9wcylcblxuICBmdW5jdGlvbiB3aXRoTG9hZGVyIChwcm9wcykge1xuICAgIHJldHVybiBwcm9wcy5pc0xvYWRpbmdcbiAgICAgID8gPFNwaW5uZXIgey4uLnNwaW5uZXJQcm9wc30gLz5cbiAgICAgIDogPENvbXBvc2VkQ29tcG9uZW50IHsuLi5wcm9wc30gLz5cbiAgfVxuXG4gIHdpdGhMb2FkZXIuZGlzcGxheU5hbWUgPSBgd2l0aExvYWRlcigke0NvbXBvc2VkQ29tcG9uZW50LmRpc3BsYXlOYW1lfSlgXG5cbiAgd2l0aExvYWRlci5wcm9wVHlwZXMgPSB7XG4gICAgaXNMb2FkaW5nOiBQcm9wVHlwZXMuYm9vbC5pc1JlcXVpcmVkXG4gIH1cblxuICByZXR1cm4gd2l0aExvYWRlclxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/withLoader.js
// module id = 1139
// module chunks = 0